/**
 * Retorna os dados da equipe vinculada.
 *
 * @param {Object} item Cadastro
 * @return {String}
 */
function equipeVinculada(item) {
  if (!item.equipe_vinculada) {
    return ''
  }

  const ine = item.equipe_vinculada.nu_ine ?? ''
  const equipe = item.equipe_vinculada.no_equipe ?? ''

  if (!ine && !equipe) {
    return ''
  }

  if (!ine) {
    return equipe
  }

  if (!equipe) {
    return ine
  }

  return `${ine} - ${equipe}`
}

export const dataFields = {
  CNES: {
    field: 'nu_cnes',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  'Unidade de Saúde': 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  Equipe: 'no_equipe',
  'Tipo equipe': 'sg_tipo_equipe',
  'Equipe vinculada': {
    callback: (item) => equipeVinculada(item),
  },
}
